var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbChevronRightCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib-chevron-right-circle_svg__clip0_1030_62101)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#09A4D8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 3.333a6.667 6.667 0 100 13.334 6.667 6.667 0 000-13.334zM1.667 10a8.333 8.333 0 1116.666 0 8.333 8.333 0 01-16.666 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.577 13.09a.833.833 0 001.179 0l2.5-2.5a.833.833 0 000-1.18l-2.5-2.5a.833.833 0 10-1.179 1.18L10.488 10l-1.91 1.91a.833.833 0 000 1.18z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-chevron-right-circle_svg__clip0_1030_62101"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.667 1.667)",
    d: "M0 0h16.667v16.667H0z"
  })))));
}

export default SvgIbChevronRightCircle;